function setCookie(cname, cvalue, exdays) {
  var df = 0;
  if( exdays > 0 ) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    df = d.toUTCString();
  }
  var expires = "expires="+df;
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/;SameSite=Lax;";
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

/*
function checkCookie(cname) {
  if (!getCookie(cname)) {
    alertlatestID.classList.remove("is-hidden");
  }
}
checkCookie("alertlatest");
*/